import Loadable from 'react-loadable';

export const PushInventoryApiDoc = Loadable({
  loader: () => import('./PushInventoryApiDoc'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/containers/PushInventoryApiDoc/index.tsx